module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "profile-text"
  }, [_c('h4', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.$t('project.descriptionLanguage')) + ":")]), _vm._v(" "), (_vm.project.translations) ? _c('div', {
    staticClass: "row select-language-buttons"
  }, _vm._l((_vm.project.translations), function(language) {
    return _c('div', {
      staticClass: "col-lg-4 col-xs-6"
    }, [_c('button', {
      staticClass: "select-language-btn sm text-center",
      class: [{
        crowd: _vm.project.crowdfunding,
        raise: !_vm.project.crowdfunding,
        active: language.locale === _vm.locale
      }],
      attrs: {
        "value": language.locale,
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.changeLanguage(language.locale)
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.$t(("language." + (language.locale)))) + "\n            ")])])
  }), 0) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.$t('project.form.shortDescription')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.translation.description),
      expression: "project.translation.description"
    }],
    staticClass: "form-control my-short-desc",
    attrs: {
      "disabled": !_vm.isEditable,
      "rows": "7",
      "maxlength": "150",
      "placeholder": _vm.$t('project.form.shortDescriptionPlaceholder')
    },
    domProps: {
      "value": (_vm.project.translation.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project.translation, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": !_vm.isEditable
    }
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "profile-photo"
  }, [(_vm.project.id) ? _c('div', [(_vm.image) ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.image
    }
  }), _vm._v(" "), (_vm.newImage) ? _c('button', {
    class: 'btn btn-default btn-lg mb-0 button-wide-' + _vm.crowd_or_rais,
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeImage($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')))]) : _vm._e()]) : (_vm.project.photo.url) ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.$server_url + _vm.project.photo.url + '?cachingPrevent' + Math.random()
    }
  })]) : _c('img', {
    attrs: {
      "src": require("assets/img/do-more-img-4-3.gif")
    }
  })]) : _c('div', [(_vm.image) ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.image
    }
  }), _vm._v(" "), (_vm.newImage) ? _c('button', {
    class: 'btn btn-default btn-lg mb-0 button-wide-' + _vm.crowd_or_rais,
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeImage($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')))]) : _vm._e()]) : (_vm.project.photo.url) ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.$server_url + _vm.project.photo.url
    }
  })]) : _c('img', {
    attrs: {
      "src": require("assets/img/do-more-img-4-3.gif")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "profile-right"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t("project.form.campaignPhoto")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("project.form.campaignPhotoDescription")))]), _vm._v(" "), _c('button', {
    class: 'btn btn-default btn-lg mb-0 button-wide-' + _vm.crowd_or_rais,
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.file_input.$refs.input.click()
      }
    }
  }, [(_vm.project.photo) ? _c('span', [_vm._v(_vm._s(_vm.$t("project.form.updatePhotoButton")))]) : _c('span', [_vm._v(_vm._s(_vm.$t("project.form.addPhotoButton")))])]), _vm._v(" "), _c('upload-base64', {
    ref: "file_input",
    attrs: {
      "multiple": false,
      "done": _vm.getFiles
    }
  }), _vm._v(" "), (_vm.sizeError) ? _c('div', {
    staticClass: "has-error"
  }, [_c('p', {
    staticClass: "help-block pt-5 mb-0"
  }, [_vm._v(_vm._s(_vm.$t("profile.edit.photoSizeError")))])]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("project.form.campaignVideo")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("project.form.campaignVideoContent")))]), _vm._v(" "), _c('form-error', {
    staticClass: "position-relative",
    attrs: {
      "errors": _vm.videoUrlError,
      "attribute": 'video_url'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.videoInput),
      expression: "videoInput"
    }],
    staticClass: "form-control pr-20",
    attrs: {
      "placeholder": _vm.$t('project.form.campaignVideoDescription')
    },
    domProps: {
      "value": (_vm.videoInput)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.videoInput = $event.target.value
      }, _vm.checkIfEmpty]
    }
  }), _vm._v(" "), (_vm.videoInput.length) ? _c('div', {
    class: 'clear-input-' + _vm.crowd_or_rais,
    on: {
      "click": _vm.deleteVideo
    }
  }, [_vm._v("×")]) : _vm._e()]), _vm._v(" "), _c('button', {
    class: 'btn btn-default btn-lg mb-0 button-wide-' + _vm.crowd_or_rais,
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addVideo
    }
  }, [_vm._v(_vm._s(_vm.$t("project.form.addVideoButton")))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.project.video_url),
      expression: "project.video_url"
    }],
    class: 'btn btn-default btn-lg mb-0 button-wide-' + _vm.crowd_or_rais,
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteVideo
    }
  }, [_vm._v(_vm._s(_vm.$t("project.form.removeVideoButton")))])], 1)])])]), _vm._v(" "), (_vm.project.video_url) ? _c('div', {
    staticClass: "row mt-30"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    ref: "videoRef",
    attrs: {
      "src": _vm.project.video_url.replace('watch?v=', 'embed/'),
      "id": "video-container",
      "controls": ""
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row mt-30",
    staticStyle: {
      "min-height": "300px"
    }
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('h4', {
    staticClass: "mb-20"
  }, [_vm._v(_vm._s(_vm.$t("project.form.longDescriptionTitle")))]), _vm._v(" "), _c('trumbowyg', {
    ref: "trumbowyg",
    attrs: {
      "content": _vm.project.translation.story,
      "placeholder": _vm.$t('project.form.longDescription'),
      "disabled": !_vm.isEditable
    },
    on: {
      "tbwblur": _vm.setStory
    }
  }), _vm._v(" "), (_vm.project.translations.length < _vm.languages.length) ? _c('button', {
    class: 'btn btn-default btn-lg uppercase button-wide-' + _vm.crowd_or_rais,
    attrs: {
      "disabled": !_vm.isEditable,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addTranslationModalVisible = true
      }
    }
  }, [(!_vm.submit.processing) ? _c('span', [_vm._v(_vm._s(_vm.$t('project.form.addTranslation')))]) : _vm._e(), _vm._v(" "), _c('clip-loader', {
    attrs: {
      "loading": _vm.submit.processing,
      "color": '#fff'
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [(_vm.addTranslationModalVisible) ? _c('modal', {
    attrs: {
      "close": function () {
        _vm.addTranslationModalVisible = false
      }
    }
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Select language")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.languages), function(language) {
    return (!_vm.translationExists(language.locale)) ? _c('div', {
      staticClass: "col-lg-3 col-xs-4"
    }, [_c('button', {
      staticClass: "select-language-btn text-center",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addTranslation(language)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.$t(("language." + (language.locale)))) + "\n                ")])]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })]) : _vm._e()], 1), _vm._v(" "), (_vm.project.id) ? _c('p', [_c('b', [_vm._v(_vm._s(_vm.$t('project.form.addNextTranslationInfo')))])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "margin": "auto",
      "margin-top": "0"
    }
  }, [_c('div', {
    staticClass: "all-categories mb-20",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t("profile.edit.outsideLinks")))])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": !_vm.isEditable
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.facebook),
      expression: "project.facebook"
    }],
    staticClass: "form-control mb-20",
    attrs: {
      "placeholder": "Facebook Link"
    },
    domProps: {
      "value": (_vm.project.facebook)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "facebook", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.twitter),
      expression: "project.twitter"
    }],
    staticClass: "form-control mb-20",
    attrs: {
      "placeholder": "Twitter Link"
    },
    domProps: {
      "value": (_vm.project.twitter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "twitter", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.youtube),
      expression: "project.youtube"
    }],
    staticClass: "form-control mb-20",
    attrs: {
      "placeholder": "YouTube Link"
    },
    domProps: {
      "value": (_vm.project.youtube)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "youtube", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.google),
      expression: "project.google"
    }],
    staticClass: "form-control mb-20",
    attrs: {
      "placeholder": "Google Plus Link"
    },
    domProps: {
      "value": (_vm.project.google)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "google", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.custom_link),
      expression: "project.custom_link"
    }],
    staticClass: "form-control mb-20",
    attrs: {
      "placeholder": "Your website link"
    },
    domProps: {
      "value": (_vm.project.custom_link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "custom_link", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), (_vm.showSaveButton() && _vm.isEditable) ? _c('button', {
    class: 'btn btn-default btn-lg uppercase button-wide-' + _vm.crowd_or_rais,
    attrs: {
      "disabled": _vm.submit.processing,
      "type": "button"
    },
    on: {
      "click": _vm.saveProject
    }
  }, [(!_vm.submit.processing) ? _c('span', [_vm._v(_vm._s(_vm.$t("save")))]) : _vm._e(), _vm._v(" "), _c('clip-loader', {
    attrs: {
      "loading": _vm.submit.processing,
      "color": '#fff'
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.showSaveButton()) ? _c('button', {
    class: 'btn btn-default btn-lg button-wide-' + _vm.crowd_or_rais,
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editProject(_vm.redirectToEdit)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('next')))]) : _vm._e(), _vm._v(" "), _c('alert', {
    attrs: {
      "success": _vm.alert.success,
      "error": _vm.alert.error
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8912fcc2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Project/Form/Details.vue
// module id = 827
// module chunks = 1